import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import { ZnInitializationHook } from '@zendra/shared';

const appName = environment.application.name;
document.cookie = `ZendraModule=${encodeURIComponent(appName)}; path=/; SameSite=Lax; Secure; Domain=.upmuruguay.net`;

if (environment.production) {
  enableProdMode();
}

if (environment.newRelicFrontend.isEnabled) {
  loadBrowserAgentScript();
}

function loadBrowserAgentScript(): void {
  if (!environment.production) {
    return;
  }

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;

  const fileName = 'newrelic-browser-agent.js';

  script.src = `assets/observability/${fileName}`;
  document.head.appendChild(script);
}

bootstrapApplication(AppComponent, appConfig)
.then(appRef => {
  const navMonitor = appRef.injector.get(ZnInitializationHook);
    navMonitor.initialize();
})
.catch(err => console.error(err));
